import React, { useState } from 'react'
import { toast } from 'react-toastify'
import Modal from '../../../components/Modal'
import { createProfession, createState } from '../../../components/services'
import { TOAST_CONFIG } from '../../../config/constants'

export default function AddProfessionModal({setModal,setProfessions}) {
    const [name,setName] = useState('')
    const _createProfession = async(e)=>
    {
        e.preventDefault();
        try 
        {
            let res = await createProfession(name)
            setProfessions(prev=>([...prev,res]))
            setModal(false)

        } catch (error) {
            toast.error(error,TOAST_CONFIG)
        }
    }
  return (
    <Modal title="Add Profession" size="md">
        <form onSubmit={_createProfession}>
        <div className="modal-inner-content">
            <div className="input-group">
                <label>Enter Profession Name</label>
                <input type="text" className="text-input" required value={name} onChange={(e)=>setName(e.target.value)}/>
            </div>
        </div>
        <div className="modal-footer">
            <input type="button" value="Cancel" className="xs-neutral-btn" onClick={()=>setModal(false)}/>
            <input type="submit" className="xs-delete-btn" value="Create State"/>
        </div>
        </form>
    </Modal>
  )
}
